import ContentChartWrapper from './ContentChartWrapper'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    chartTypeFilter: state.FILTERS.chartTypeFilter
  }
}

export default connect(mapStateToProps)(ContentChartWrapper)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartWrapper/index.js